export const GET_SOFT_COSTS_REQUEST = "GET_SOFT_COSTS_REQUEST";
export const GET_SOFT_COSTS_SUCCESS = "GET_SOFT_COSTS_SUCCESS";
export const GET_SOFT_COSTS_FAILURE = "GET_SOFT_COSTS_FAILURE";

export const SAVE_SOFT_COSTS_REQUEST = "SAVE_SOFT_COSTS_REQUEST";
export const SAVE_SOFT_COSTS_SUCCESS = "SAVE_SOFT_COSTS_SUCCESS";
export const SAVE_SOFT_COSTS_FAILURE = "SAVE_SOFT_COSTS_FAILURE";

export const EXPORT_EXCEL_REQUEST = "EXPORT_EXCEL_REQUEST";
export const EXPORT_EXCEL_SUCCESS = "EXPORT_EXCEL_SUCCESS";
export const EXPORT_EXCEL_FAILURE = "EXPORT_EXCEL_FAILURE";

export const SAVE_DYNAMIC_SOFT_COST_FIELD_REQUEST = "SAVE_DYNAMIC_SOFT_COST_FIELD_REQUEST";
export const SAVE_DYNAMIC_SOFT_COST_FIELD_SUCCESS = "SAVE_DYNAMIC_SOFT_COST_FIELD_SUCCESS";
export const SAVE_DYNAMIC_SOFT_COST_FIELD_FAILURE = "SAVE_DYNAMIC_SOFT_COST_FIELD_FAILURE";

export const UPDATE_DYNAMIC_SOFT_COST_FIELD_REQUEST = "UPDATE_DYNAMIC_SOFT_COST_FIELD_REQUEST";
export const UPDATE_DYNAMIC_SOFT_COST_FIELD_SUCCESS = "UPDATE_DYNAMIC_SOFT_COST_FIELD_SUCCESS";
export const UPDATE_DYNAMIC_SOFT_COST_FIELD_FAILURE = "UPDATE_DYNAMIC_SOFT_COST_FIELD_FAILURE";

export const DELETE_DYNAMIC_SOFT_COST_FIELD_REQUEST = "DELETE_DYNAMIC_SOFT_COST_FIELD_REQUEST";
export const DELETE_DYNAMIC_SOFT_COST_FIELD_SUCCESS = "DELETE_DYNAMIC_SOFT_COST_FIELD_SUCCESS";
export const DELETE_DYNAMIC_SOFT_COST_FIELD_FAILURE = "DELETE_DYNAMIC_SOFT_COST_FIELD_FAILURE";

export const RESET_SOFT_COST_REQUEST = "RESET_SOFT_COST_REQUEST";
export const RESET_SOFT_COST_SUCCESS = "RESET_SOFT_COST_SUCCESS";
export const RESET_SOFT_COST_FAILURE = "RESET_SOFT_COST_FAILURE";

export const COLOR_PALETTE = [
    { light: "#fff0f2", dark: "#f9c6ca" },
    { light: "#fff8f3", dark: "#ffd4b2" },
    { light: "#f7fdfa", dark: "#bff1cb" },
    { light: "#f3f9fe", dark: "#b4d4f8" },
    { light: "#f8effe", dark: "#cfaefb" },
    { light: "#fffcee", dark: "#f8cd7f" },
    { light: "#f7fdf4", dark: "#c5e4b6" },
    { light: "#ecfcff", dark: "#9cdcf9" },
    { light: "#fffaf1", dark: "#ffbf9d" },
    { light: "#f9f2ff", dark: "#dcb6ff" }
];
